export default __webpack_public_path__ + "static/media/personality-test-indigo.34efdbf2.png";